export enum Platform {
  PlayId = "playid",
  FunId = "funid",
  BoomId = "boom-id",
  OnePass = "onepass",
  Default = "default",
}
